import zoomOutIcon from '../../../assets/icons/zoom_out.svg';
import { TImgContent } from '../../../utils/types/agrocraftArtisan';
import { useZoomOutMutation } from '../../../services/agrocraftArtisan';
import './index.scss';
import { CircularProgress, Tooltip } from '@mui/material';

type TProps = {
  img: TImgContent;
  sessionId: number;
  prompt: string;
  setIsScrollToLatest: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  chatId: number;
  onZoomOutComplete?: () => void;
};

export const ZoomOut = ({
  img,
  sessionId,
  prompt,
  setIsScrollToLatest,
  chatId,
  onZoomOutComplete,
}: TProps) => {

  const [zoomOutAPI, { isLoading }] = useZoomOutMutation();

  const onZoomOut = () => {
    setIsScrollToLatest(true);
    zoomOutAPI({
      sessionId,
      data: {
        index: img.index,
        prompt: prompt,
        chat_id: chatId,
        image_id: img.image_id,
      },
    })
      .unwrap()
      .then(() => {
        if (onZoomOutComplete) {
          onZoomOutComplete();
        }
      })
      .catch(() => { });
  };

  const isDisabled = img.outpaint_flag || isLoading;

  return (
    <div>
      <Tooltip title="Enlarge image">
        <a
          onClick={() => !isDisabled && onZoomOut()}
          className={`flex items-center gap-2 ${isDisabled ? 'disabled' : ''
            }`}>
          <img src={zoomOutIcon} />
          {isLoading && (
            <CircularProgress
              color="inherit"
              thickness={5}
              style={{ width: 16, height: 16 }}
            />
          )}
        </a>
      </Tooltip>
    </div>
  );
};
